<div class="indicator-detail-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">
      Indikator Details
    </h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="indicator-info">
      <!-- Symbol and Number -->
      <div class="symbol-section">
        <div class="symbol-container">
          <ng-container *ngIf="getIndicatorSymbolUrl(data.indicator)">
            <div *ngIf="getIndicatorSymbolColor(data.indicator); else noColorSymbol"
                 class="symbol-icon"
                 [style.mask-image]="'url(' + getIndicatorSymbolUrl(data.indicator) + ')'"
                 [style.-webkit-mask-image]="'url(' + getIndicatorSymbolUrl(data.indicator) + ')'"
                 [style.mask-size]="'contain'"
                 [style.mask-repeat]="'no-repeat'"
                 [style.mask-position]="'center'"
                 [style.background-color]="getIndicatorSymbolColor(data.indicator)">
            </div>
            <ng-template #noColorSymbol>
              <img [src]="getIndicatorSymbolUrl(data.indicator)" 
                   [alt]="data.indicator.indikator?.code || 'Symbol'"
                   class="symbol-icon">
            </ng-template>
          </ng-container>
        </div>
        <div class="number-badge">
          #{{ getFormattedIndicatorNumber(data.indicator.indikator_number) }}
        </div>
      </div>

      <!-- Basic Information -->
      <div class="info-section">
        <div class="info-row">
          <span class="info-label">Typ/Code:</span>
          <span class="info-value">{{ getIndikatorCode() }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Name:</span>
          <span class="info-value">{{ data.indicator.name }}</span>
        </div>
        <div class="info-row" *ngIf="data.indicator.room">
          <span class="info-label">Raum:</span>
          <span class="info-value">{{ data.indicator.room.name || '-' }}</span>
        </div>
        <div class="info-row" *ngIf="data.indicator.room?.sektion">
          <span class="info-label">Sektion:</span>
          <span class="info-value">{{ data.indicator.room.sektion.name || '-' }}</span>
        </div>
        <div class="info-row" *ngIf="data.indicator.room?.sektion?.gebaeude">
          <span class="info-label">Gebäude:</span>
          <span class="info-value">{{ data.indicator.room.sektion.gebaeude.name || '-' }}</span>
        </div>
        <div class="info-row" *ngIf="getSystemtypCaption()">
          <span class="info-label">Systemtyp:</span>
          <span class="info-value">{{ getSystemtypCaption() }}</span>
        </div>
        <div class="info-row" *ngIf="getSystemgruppeCaption()">
          <span class="info-label">Systemgruppe:</span>
          <span class="info-value">{{ getSystemgruppeCaption() }}</span>
        </div>
      </div>

      <!-- Additional Information -->
      <div class="additional-section" *ngIf="data.indicator.bemerkung">
        <h3 class="section-title">Bemerkung</h3>
        <p class="bemerkung-text">{{ data.indicator.bemerkung }}</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onClose()" class="close-button-action">
      Schließen
    </button>
  </mat-dialog-actions>
</div>



